import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Card, Row, StateScreen } from '@cowoo/shared/ui-web';
import { STALE_TIME, formatDate, qk } from '@cowoo/shared';
import { api } from '../../lib/api';

/**
 * `/mitglied` — the one screen that outlives the funnel (D-005).
 *
 * It shows the running contract and the tariff-switch rule (BR-CON-02): a
 * second membership is not bought here, it replaces the current one from the
 * next month.
 */
export function Membership() {
  const { t } = useTranslation();

  const contracts = useQuery({
    queryKey: qk.contracts(),
    staleTime: STALE_TIME.contracts,
    queryFn: async () => {
      const { data, error } = await api.GET('/me/contracts');
      if (error || !data) throw error ?? new Error('contracts unavailable');
      return data;
    },
  });

  if (contracts.isLoading) return <StateScreen title={t('common.loading')} />;

  const items = contracts.data?.items ?? [];
  if (items.length === 0) return <StateScreen title={t('member.membership.none')} />;

  return (
    <main className="mx-auto max-w-2xl px-5 py-12">
      <h1 className="font-heading text-ink mb-6 text-3xl">{t('member.membership.title')}</h1>
      {items.map((contract) => (
        <Card key={contract.id} className="mb-4">
          <h2 className="font-heading text-ink mb-3 text-xl">{t(`product.${contract.productKey}.name`)}</h2>
          <Row
            label={t('member.membership.status')}
            value={t(`member.membership.state.${contract.status}`)}
          />
          <Row label={t('member.membership.since')} value={formatDate(contract.startDay)} />
          {contract.endDay ? (
            <Row label={t('member.membership.until')} value={formatDate(contract.endDay)} />
          ) : null}
        </Card>
      ))}
    </main>
  );
}
